import localStorage from 'localStorage';

const PAGE = 'page';
const PAGE_NUMBER = 'pageNumber';
const ORDER_BY = 'orderBy';
export default {
  page(tableName) {
    return localStorage.getItem(`${tableName}:${PAGE}`);
  },
  setPage(tableName, page) {
    localStorage.setItem(`${tableName}:${PAGE}`, page);
  },
  pageNumber(tableName) {
    return localStorage.getItem(`${tableName}:${PAGE_NUMBER}`);
  },
  setPageNumber(tableName, pageNumber) {
    localStorage.setItem(`${tableName}:${PAGE_NUMBER}`, pageNumber);
  },
  orderBy(tableName) {
    return localStorage.getItem(`${tableName}:${ORDER_BY}`);
  },
  setOrderBy(tableName, orderBy) {
    localStorage.setItem(`${tableName}:${ORDER_BY}`, orderBy);
  },
};
